import React, { useState } from 'react';
import { RUN_TIERS } from '../utils/runTiers';

const GameRules: React.FC = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="rules-card">
      <button className="rules-trigger" onClick={() => setExpanded(value => !value)} aria-expanded={expanded} aria-controls="game-rules-content">
        <span className="rules-icon" aria-hidden="true">?</span>
        <span><strong>How to play</strong><small>Rules · Run levels · Player information</small></span>
        <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ transform: expanded ? 'rotate(180deg)' : 'none' }}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
      </button>
      {expanded && <div id="game-rules-content" className="rules-content">
        <ol>
          <li>Choose one wager while bets are open.</li>
          <li>The multiplier rises after the run begins.</li>
          <li>Cash out before the whiteout to secure the displayed return.</li>
        </ol>
        <p>Run levels are visual milestones only. They do not alter the crash result, probability, or payout calculation.</p>
        <p>The highest active wagers get the visible ski slots. The shared spotlight goes to the last successful public cashout, even if that skier was off-screen. Solo wagers and SnowBot are excluded. Exact ties are resolved consistently by the server; the spotlight adds no payout.</p>
        <p>Your cashout must reach the server before the whiteout. An auto-cashout target equal to the crash multiplier does not win.</p>
        <p>Disconnecting does not cash you out; your auto-cashout stays active. If the service interrupts a run, unresolved wagers are refunded and completed cashouts are kept.</p>
        <div className="rules-tier-list">
          {RUN_TIERS.map(tier => <div key={tier.id}><span style={{ background: tier.color }} /><strong>{tier.name}</strong><small>{tier.next ? `${tier.min.toFixed(2)}–${tier.next.toFixed(2)}x` : `${tier.min.toFixed(2)}x+`}</small></div>)}
        </div>
        <p className="rules-responsibility">18+ · Credits are free and have no cash value.</p>
      </div>}
    </div>
  );
};

export default GameRules;
